import React from 'react';
import type { TFunction } from 'i18next';
import { formatCurrency } from '../../../utils/formatCurrency';
import { CARD_SHADOW } from '../constants';

export interface PlanCardProps {
  planName: string;
  planTagline: string;
  planUsers: string;
  planPromo: number;
  language: string;
  t: TFunction;
  onChange: () => void;
}

export function PlanCard({ planName, planTagline, planUsers, planPromo, language, t, onChange }: PlanCardProps): React.ReactElement {
  return (
    <div className="mb-3.5 rounded-xl border border-hairline bg-white" style={{ padding: "22px 24px", boxShadow: CARD_SHADOW }}>
      <div className="flex items-start justify-between gap-4">
        <div className="flex-1">
          <div className="inline-block rounded font-extrabold text-brand" style={{ fontSize: 10, background: "#DCFCE7", padding: "3px 10px", letterSpacing: "0.08em" }}>{t("cart.labels.subscription")}</div>
          <div className="mt-2.5 font-extrabold text-ink" style={{ fontSize: 20, letterSpacing: "-0.01em" }}>{planName}</div>
          <div className="mt-1 text-small text-sub leading-normal">{planTagline + ". " + planUsers}</div>
        </div>
        <div className="whitespace-nowrap text-right">
          <div className="font-extrabold text-ink" style={{ fontSize: 22 }}>{formatCurrency(planPromo, language)}</div>
          <div className="mt-0.5 text-tiny text-muted">{t("cart.perMonth")}</div>
        </div>
      </div>
      <button onClick={onChange} className="mt-3.5 cursor-pointer rounded-[10px] border border-stroke bg-white px-4 py-2 text-small font-semibold text-ink font-sans" style={{ boxShadow: "0 1px 2px rgba(0,0,0,0.05)" }}>{t("cart.change")} plan</button>
    </div>
  );
}
